module.exports = __webpack_public_path__ + "static/media/faqs-poster.78b1e4e8.png";